import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL preservation: /reminders/birthday/add/manual was the old standalone
// "Add Birthdays" form (linked from the Add Reminders footer and the how-to page). The
// add-birthday dialog covers it — land on /reminders with it open.
export const Route = createFileRoute("/reminders_/birthday_/add_/manual")({
  beforeLoad: () => {
    throw redirect({ to: "/reminders", search: { add: true }, replace: true });
  },
});
